import { NotificationService } from 'src/app/Shared/prime-ng/notification.service';
import { DataResult, DataStateChangeEvent, GridDataResult, PageChangeEvent, State, pageSkip, pageTake, process } from 'src/app/Shared/prime-ng/grid-data';
import { PrimeNgModule } from 'src/app/Shared/prime-ng/prime-ng.module';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerDTO } from 'src/app/DTOs/CustomerDTO';
import { MasterDataService } from 'src/app/Services/master-data.service';
import { FormGroup, FormsModule, } from "@angular/forms";
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CountryDTO } from 'src/app/DTOs/CountryDTO';
import { ContactPersonDTO } from 'src/app/DTOs/ContactPersonDTO';

@Component({
  selector: 'app-customer-detail',
  standalone: true,
  imports: [PrimeNgModule, FormsModule,
    CommonModule, RouterModule],
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.css']
})

export class CustomerDetailComponent implements OnInit {
  customer: CustomerDTO | null = {
    customerId: 0,
    // customerId: 0,
    title: '',
    country: {
      countryId: 0,
      title: '',
      iso2: null,
      iso3: null
    },
    city: '',
    zip: '',
    street: '',
    contactPersons: [],
    canBeDeleted: false
  };
  availableCountrys: CountryDTO[] = [{ countryId: 0, iso2: null, iso3: null, title: '' }]
  public contactPersons: ContactPersonDTO[] = [];
  public currentContactPersons: ContactPersonDTO[] = [];
  public orginalContactPerson: ContactPersonDTO[] = [];
  public gridView: GridDataResult = { data: [], total: 0 };
  public gridState: State = { skip: 0, take: 5 };
  selectedCountryId: number = 0
  editMode: boolean = false
  cancelDialog: boolean = false

  constructor(private route: ActivatedRoute, private masterData: MasterDataService, private router: Router, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.loadCustomerDetail()
    this.getAllCountrys()
    this.updateGridView()
  }

  saveCustomer() {
    if (!this.customer) {
      this.notification('No Customer was loaded!', 'error');
      return;
    }

    const selectedCountry = this.availableCountrys.find(c => c.countryId === this.selectedCountryId);
    if (!selectedCountry) {
      this.notification('Please select a Country!', 'error');
      return;
    }
    this.customer.country = selectedCountry;
    this.customer.contactPersons = this.contactPersons;

    if (this.customer.customerId && this.customer.customerId > 0) {
      this.masterData.updateCustomer(this.customer).subscribe({
        next: () => {
          this.notification('Customer was updated', 'success');
          this.router.navigate(['/customers']);
        },
        error: () => this.notification('Error while updating Customer', 'error')
      });
    } else {
      this.masterData.createCustomer(this.customer).subscribe({
        next: (id: number) => {
          this.customer!.customerId = id;
          this.notification(`Customer was created (ID: ${id})`, 'success');
          this.router.navigate(['/customers']);
        },
        error: () => this.notification('Error while creating Customer', 'error')
      });
    }
  }


  cancelEdit() {
    this.customer = null;
    this.router.navigate([`customers/`])
  }

  getAllCountrys() {
    this.masterData.GetAllCountrys().subscribe({
      next: (res) => {
        if (res) {
          this.availableCountrys = res;
          if (this.customer) {
            if (this.customer.country && this.customer.country.countryId) {
              this.selectedCountryId = this.customer.country.countryId;
            } else {
              this.customer.country = this.availableCountrys[0];
              this.selectedCountryId = this.customer.country.countryId;
            }
          }
        }
      },
      error: () => this.notification('Error while loading countries', 'error')
    });
  }

  private updateGridView() {
    this.gridView = process(this.contactPersons, this.gridState);
  }

  public dataStateChange(state: State): void {
    this.gridState = state;
    this.updateGridView();
  }

  public addHandler() {
    try {
      const newContactPerson: ContactPersonDTO = {
        databaseId: 0,
        firstName: 'First Name',
        lastName: 'Last Name',
        canBeDeleted: true,
      };
      this.contactPersons = [...this.contactPersons, newContactPerson];
      this.updateGridView()
      this.notification('New Contactperson was added', 'success');
    } catch {
      this.notification('Error while saving Contactperson', 'error');
    }
  }
  public editHandler() {
    this.editMode = !this.editMode
    this.currentContactPersons = this.contactPersons.map(cp => ({ ...cp }))
  }

  public openCancelDialog() {
    this.cancelDialog = true;
  }

  public cancelHandler() {
    try {
      this.contactPersons = this.orginalContactPerson.map(cp => ({ ...cp }))
      this.toggleCancelDialog()
      this.updateGridView();
      this.notification('Changes were canceled', 'info');
      this.router.navigate(['/customers']);
    } catch {
      this.notification('Error while canceling the changes', 'error');
    }
  }
  public saveHandler() {
    this.editMode = !this.editMode
    this.updateGridView();
  }

  public removeHandler(item: ContactPersonDTO) {
    const index = this.contactPersons.indexOf(item);
    if (index > -1) {
      this.contactPersons.splice(index, 1);
      this.updateGridView();
      this.notification(`Contactperson "${item.firstName} ${item.lastName}" was removed`, 'warning');
    }
  }

  private loadCustomerDetail() {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.masterData.getCustomers(id).subscribe(customers => {
        this.customer = customers[0];
        if (this.customer && this.customer.country) {
          this.selectedCountryId = this.customer.country.countryId
          this.contactPersons = this.customer.contactPersons.map(cp => ({ ...cp }));
          this.orginalContactPerson = this.contactPersons.map(cp => ({ ...cp }));
          this.updateGridView();
        }
      });
    }
  }

  toggleCancelDialog() {
    this.cancelDialog = !this.cancelDialog
  }

  notification(message: string, state: any) {
    this.notificationService.show({
      content: message,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: state, icon: true }
    });
  }

}


